import { useMutation } from "urql";
import { graphql } from "../gql";

export const updateProfileMutation = graphql(`
  mutation updateProfileMutation($firstName: String, $lastName: String) {
    updateProfile(firstName: $firstName, lastName: $lastName) {
      id
      firstName
      lastName
    }
  }
`);

export function useUpdateProfileMutation() {
  return useMutation(updateProfileMutation);
}
